import {SAVE_TIPOS_ENVIO, TipoEnvioActionTypes} from "../types/tipoEnvioActionTypes";
import {ITipoEnvio} from "../../entities/catalogos/ITipoEnvio";

export default function tipoEnvioReducer(state = [], action: TipoEnvioActionTypes): ITipoEnvio[]{
    switch (action.type) {
        case SAVE_TIPOS_ENVIO:
            return action.tiposEnvio;
        default:
            return state;
    }
}
